module.exports = __webpack_public_path__ + "static/media/chartjs-logo.ed2f373e.svg";